export default __webpack_public_path__ + "static/Dr.SubratAcharya-ab68c7d53bef00bfe1dc1b867795a41a.png";